export default "__VITE_ASSET__CHF5DLrb__"